/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { useState } from 'react'
import { Modal, Checkbox, Row, Col } from 'antd'

const ALL_CALCS = ['Sum', 'Avg', 'Min', 'Max']

const CalcModal = ({ profile, setProfile, hide }) => {
  const [selectedCols, setSelectedCols] = useState(
    (profile.calculations && profile.calculations.split(',')) || []
  )

  const onOk = () => {
    setProfile({
      ...profile,
      calculations: selectedCols.join(','),
    })
    hide()
  }

  const selectAllClicked = e => {
    if (e.target.checked) {
      setSelectedCols(ALL_CALCS)
    } else {
      setSelectedCols([])
    }
  }

  return (
    <Modal
      title="Select Calc."
      width="20vw"
      visible
      onOk={onOk}
      okText="Ok"
      onCancel={hide}
      centered
      maskClosable={false}
    >
      <div
        css={{
          marginBottom: 10,
          paddingBottom: 5,
          borderBottom: '1px lightgrey solid',
        }}
      >
        <Checkbox
          checked={selectedCols.length === ALL_CALCS.length}
          onChange={selectAllClicked}
        >
          Select All
        </Checkbox>
      </div>
      <Checkbox.Group
        value={selectedCols}
        style={{ width: '100%' }}
        onChange={values => setSelectedCols(values)}
      >
        <Row>
          {ALL_CALCS.map(calc => {
            return (
              <Col key={calc} span={12} css={{ marginBottom: 10 }}>
                <Checkbox value={calc}>{calc}</Checkbox>
              </Col>
            )
          })}
        </Row>
      </Checkbox.Group>
    </Modal>
  )
}

export default CalcModal
